module.exports = "<app-navbar></app-navbar>\n<div class=\"page\">\n  <router-outlet></router-outlet>\n</div>\n"